import React, { useEffect } from 'react';
import { useCookieConsent } from '../hooks/useCookieConsent';

// Replace with your actual Google Analytics Measurement ID
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX';

// Declare global gtag function
declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export const AnalyticsScripts: React.FC = () => {
  const { preferences } = useCookieConsent();

  useEffect(() => {
    // Logic to load or unload analytics scripts based on user preferences
    if (preferences.analytics) {
      // Google Analytics script loading
      // This is just a template - implementation would vary based on specific analytics service
      const loadGoogleAnalytics = () => {
        // Check if the script is already loaded
        if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
          return;
        }

        // Create and append the Google Analytics script
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        script.async = true;
        document.head.appendChild(script);

        // Initialize gtag
        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
          window.dataLayer?.push(args);
        }
        gtag('js', new Date());
        gtag('config', GA_MEASUREMENT_ID);

        // Store gtag globally
        window.gtag = gtag;
      };

      loadGoogleAnalytics();
    } else {
      // If analytics not allowed, remove analytics scripts if they exist
      const removeGoogleAnalytics = () => {
        // Remove the script tag
        const scripts = document.querySelectorAll('script[src*="googletagmanager.com/gtag/js"]');
        scripts.forEach(script => script.remove());

        // Reset global variables
        delete window.dataLayer;
        delete window.gtag;

        // Remove cookies associated with Google Analytics
        document.cookie = '_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = '_gat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = '_gid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      };

      removeGoogleAnalytics();
    }
  }, [preferences.analytics]);

  return null; // This component doesn't render anything
}; 